<script>
    import {PATH_PREFIX} from '../../../../apiUrls.js';
    export let row = null;
</script>

<style>

</style>

{#if row.has_access}
<a href={`${PATH_PREFIX}/sw/builder/activityversion/${row.activity_version.id}/detail/`} target="_blank" rel="noopener noreferrer"
   class="d-inline-block pt-2">
    {#if row.activity_version.invalid_element_count}<i class="fa fa-exclamation-circle text-danger"></i>{/if}
    {row.activity_version.name}
</a>

{:else}
    {#if row.activity_version.invalid_element_count}<i class="fa fa-exclamation-circle text-danger"></i>{/if}
    {row.activity_version.name}
{/if}